import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsCreateCompanyBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Create company</div>
          <div className="text">
            If you want to create a company, this can be accomplished by associating it to a user
            via the <a href="#create_or_update_user">Create or Update User</a> endpoint.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
